<div class="client-page-content">
  <p *ngIf="!payOnlyPage" class="text-gray mb-0 text-center">{{ 'CLIENT.clientConfirm.title' | translate }}</p>

  <div class="row justify-content-center">
    <div class="col-md-10 col-sm-10 col-11">
      <div class="resume">
        <p class="h6 text-center mb-1">{{ store?.name }}</p>
        <p class="text-bold mb-1">{{ day.day | dateFix | date : 'longDate' }} / {{ formatTime(time?.start) }}</p>
        <div class="mt-3 mb-3" *ngIf="onlyOneServiceWithoutPrice">
          <p class="h6 mb-1 text-bold color-black">{{services[0].name}}</p>
          <p class="text-bold mb-1 color-black" *ngIf="providers[0]?.id !== null">{{'GENERAL.with' | translate}} {{ providers[0]?.name }}</p>
        </div>
        <ul class="checkout-table" *ngIf="!onlyOneServiceWithoutPrice">
          <ng-container *ngFor="let service of services; let i = index">
            <li class="d-flex align-items-start justify-content-between">
              <div class="item">
                <p class="mb-0 text-left">{{ service?.name }}</p>
                <p class="mb-0 text-left" *ngIf="providers[i]?.id !== null">{{'GENERAL.with' | translate}} {{ providers[i]?.name }}</p>
              </div>
              <p class="mb-0 text-right" *ngIf="service.price > 0">{{ service.price | currency : merchant.currency }}</p>
            </li>
          </ng-container>
          <li class="d-flex align-items-center justify-content-between" *ngIf="totalPriceOriginal > 0">
            <p class="mb-0 text-left">{{'GENERAL.total' | translate}}</p>
            <p class="mb-0 text-right">{{ totalPriceOriginal | currency : merchant.currency }}</p>
          </li>
          <li *ngIf="store.activeDepositPayments && paymentsEnabled" class="d-flex align-items-center justify-content-between bg-gray">
            <p class="mb-0 text-left">{{'CLIENT.clientConfirm.depositBooking' | translate}}</p>
            <p class="mb-0 text-right">{{ totalPriceToBePaid | currency : merchant.currency }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-md-10 col-sm-10 col-11">
      <p *ngIf="!payOnlyPage" class="h6 text-center color-gray mb-3">{{'CLIENT.clientConfirm.bookingDataTitle' | translate}}</p>

      <form [formGroup]="form" (ngSubmit)="confirmBooking()" *ngIf="form">

        <app-text-input
          *ngIf="!payOnlyPage"
          inputClasses="mt-2"
          formControlName="name"
          [submitAttempted]="submitAttempted"
          placeholder="{{ 'CLIENT.clientConfirm.namePlaceholder' | translate }}"
          invalidMsg="{{ 'CLIENT.clientConfirm.namePlaceholder' | translate }}"
          inputType="text"
        ></app-text-input>

        <div class="form-group" *ngIf="!payOnlyPage || (payOnlyPage && form?.get('paymentMethod').value === 'mbway')">
          <app-phone-input controlName="phoneNumber" [form]="form" [submitAttempted]="submitAttempted"/>
          <div class="invalid-feedback" *ngIf="submitAttempted && !form.get('phoneNumber').valid">
            <span *ngIf="form.get('phoneNumber').invalid && !form.get('phoneNumber').errors?.ptNumber">{{
              'CLIENT.clientConfirm.invalidPhoneNumber' | translate
            }}</span>
            <span *ngIf="form.get('phoneNumber').errors?.ptNumber">{{ 'CLIENT.clientConfirm.invalidPtNumber' | translate }}</span>
          </div>
        </div>
        <app-text-input
          *ngIf="!payOnlyPage"
          formControlName="email"
          [submitAttempted]="submitAttempted"
          placeholder="{{ 'CLIENT.clientConfirm.emailPlaceholder' | translate }}"
          invalidMsg="{{ 'CLIENT.clientConfirm.invalidEmail' | translate }}"
          inputType="email"
        ></app-text-input>

        <app-dropdown-input-v2
          *ngIf="merchant.showGenderOnBookingPage && !payOnlyPage"
          placeholder="{{ 'CLIENT.clientConfirm.genderPlaceholder' | translate }}"
          [options]="genderOptions"
          [submitAttempted]="submitAttempted"
          textOption="label"
          formControlName="gender"
          >
        </app-dropdown-input-v2>

        <app-text-input
          *ngIf="merchant.showVatNumberOnBookingPage || payOnlyPage"
          formControlName="vatNumber"
          [submitAttempted]="submitAttempted"
          placeholder="{{ 'CLIENT.clientConfirm.vatNumberPlaceholder' | translate }}"
          invalidMsg="{{ 'CLIENT.clientConfirm.invalidVatNumber' | translate }}"
          inputType="text"
        ></app-text-input>

        <div class="form-group mb-3" *ngIf="merchant.showDOBOnBookingPage && !payOnlyPage">
          <input type="text" [class.is-invalid]="submitAttempted && !form.get('dob').valid" class="form-control"
            placeholder="{{ 'CLIENT.clientConfirm.dobPlaceholder' | translate }}"
            bsDatepicker formControlName="dob" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }" />
          <div class="invalid-feedback" *ngIf="submitAttempted && !form.get('dob').valid">
            {{ 'CLIENT.clientConfirm.invalidDob' | translate }}
          </div>
        </div>

        <app-text-input
          *ngIf="!payOnlyPage"
          formControlName="notes"
          [submitAttempted]="submitAttempted"
          placeholder="{{ 'CLIENT.clientConfirm.notesPlaceholder' | translate }}"
          inputType="text"
        ></app-text-input>

        <!-- CUSTOM FIELDS -->
        <div class="mb-3" formArrayName="customFields" *ngIf="form.get('customFields') && !payOnlyPage">
          <div class="mb-2 label-client" *ngFor="let customField of merchantCustomFields; let i = index;" [formGroupName]="i">
            <!-- custom dropdown -->
            <app-dropdown-input
            [requiredMark]="merchantCustomFields[i].mandatory"
            *ngIf="customField.type === 'dropdown'"
            [formControlName]="'_' + merchantCustomFields[i].id"
            [label]="merchantCustomFields[i].name"
            [placeholder]="'GENERAL.chooseOption' | translate"
            invalidMsg="{{'CLIENT.clientConfirm.requiredField' | translate}}"
            [options]="merchantCustomFields[i].dropdownValues"
            [submitAttempted]="submitAttempted" />
            <!-- custom text input -->
            <app-text-input
            [requiredMark]="merchantCustomFields[i].mandatory"
            label="{{customField.name}}"
            *ngIf="customField.type === 'text'"
            formControlName="_{{ + merchantCustomFields[i].id }}"
            [submitAttempted]="submitAttempted"
            [placeholder]="customField.name"
            />
            <!-- custom date input -->
            <div class="form-group mb-3" *ngIf="customField.type === 'date'">
              <label>{{customField.name}}<span class="red" *ngIf="merchantCustomFields[i].mandatory">*</span></label>
              <input
                type="text"
                [class.is-invalid]="submitAttempted && customFieldsControls?.at(i)?.invalid"
                class="form-control"
                bsDatepicker
                formControlName="_{{ + merchantCustomFields[i].id }}"
                [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
              />
              <div class="invalid-feedback" *ngIf="submitAttempted && customFieldsControls?.at(i)?.invalid">
                {{ 'CLIENT.clientConfirm.requiredField' | translate }}
              </div>
            </div>
          </div>
        </div>

        <div class="payment-wrapper mt-3" *ngIf="paymentsEnabled && form">
          <p class="h6 mt-3 mb-3 text-center color-gray">{{ 'CLIENT.clientConfirm.paymentMethod' | translate }}</p>

          <div class="form-group checkbox-inline">
            <div
              *ngIf="applePayEnabled && store.stripePaymentsEnabled"
              class="custom-control custom-radio custom-radio-button mb-1"
              [ngClass]="{ selected: form.get('paymentMethod').value === 'applepay' }"
            >
              <input id="applepay" type="radio" value="applepay" class="custom-control-input" formControlName="paymentMethod" />
              <label class="custom-control-label label-applepay" for="applepay">Apple Pay</label>
            </div>
            <div
              *ngIf="googlePayEnabled && store.stripePaymentsEnabled"
              class="custom-control custom-radio custom-radio-button mb-1"
              [ngClass]="{ selected: form.get('paymentMethod').value === 'googlepay' }"
            >
              <input id="googlepay" type="radio" value="googlepay" class="custom-control-input" formControlName="paymentMethod" />
              <label class="custom-control-label label-googlepay" for="googlepay">Google Pay</label>
            </div>
            <div
              *ngIf="store.activeMBWay"
              class="custom-control custom-radio custom-radio-button mb-1"
              [ngClass]="{ selected: form.get('paymentMethod').value == 'mbway' }"
            >
              <input id="mbway" type="radio" class="custom-control-input" value="mbway" formControlName="paymentMethod" />
              <label class="custom-control-label label-mbway" for="mbway">MBWay</label>
            </div>

            <div *ngIf="form.get('paymentMethod').value === 'mbway'">
              <p class="mbway-info text-center mt-2 color-gray">
                {{ 'CLIENT.clientConfirm.mbwayNotification1' | translate }}
                {{ 'CLIENT.clientConfirm.mbwayNotification2' | translate }}
                {{ totalPriceToBePaid | currency : merchant.currency }}.
              </p>
            </div>

            <div *ngIf="store.mbrefPaymentsEnabled" class="custom-control custom-radio custom-radio-button mb-1"
              [ngClass]="{ selected: form.get('paymentMethod').value == 'mbref' }">
              <input id="mbref" type="radio" class="custom-control-input" value="mbref" formControlName="paymentMethod" />
              <label class="custom-control-label label-mb" for="mbref">Multibanco</label>
            </div>

            <div *ngIf="form.get('paymentMethod').value === 'mbref'">
              <p class="mbway-info text-center mt-2 color-gray">
                {{ 'CLIENT.clientConfirm.mbNotification' | translate:{time: mbrefTime} }}.
              </p>
            </div>

            <div
              *ngIf="store.stripePaymentsEnabled"
              class="custom-control custom-radio custom-radio-button mb-1"
              [ngClass]="{ selected: form.get('paymentMethod').value === 'ccard' }"
            >
              <input id="ccard" type="radio" class="custom-control-input" value="ccard" formControlName="paymentMethod" />
              <label class="custom-control-label label-ccard" for="ccard"
                >{{ 'CLIENT.clientConfirm.creditCard' | translate }}</label
              >
            </div>
            <div>
              <div class="form-group mt-2" [style.display]="form.get('paymentMethod').value === 'ccard' ? '' : 'none'">
                <div class="form-control" id="card-element">
                  <!-- Elements will create input elements here -->
                </div>
              </div>

              <!-- We'll put the error messages in this element -->
              <div
                id="card-errors"
                class="invalid-feedback"
                role="alert"
                [style.display]="form.get('paymentMethod').value === 'ccard' ? '' : 'none'"
              ></div>
            </div>
            <div
              *ngIf="!store.mandatoryPayments && !payOnlyPage"
              class="custom-control custom-radio custom-radio-button mb-1"
              [ngClass]="{ selected: form.get('paymentMethod').value === 'money' }"
            >
              <input id="money" type="radio" class="custom-control-input" value="money" formControlName="paymentMethod" />
              <label class="custom-control-label label" for="money">{{ 'CLIENT.clientConfirm.paymentMoney' | translate }}</label>
            </div>
          </div>

          <div>
            <div id="payment-request-button" [style.display]="'none'">
              <!-- A Stripe Element will be inserted here. -->
            </div>
          </div>
        </div>

        <div class="custom-control custom-checkbox mt-2 mb-3 terms">
          <!-- regular -->
          <ng-container *ngIf="!merchant.corporate">
            <!-- terms -->
            <div>
              <input formControlName="terms" type="checkbox" class="custom-control-input" id="customCheck1" />
              <label
                class="custom-control-label"
                for="customCheck1"
                [ngClass]="{ 'is-invalid': submitAttempted && !form.get('terms').valid }"
              >
                {{ 'CLIENT.clientConfirm.termsConditions1' | translate }}
                <a target="_blank" routerLink="/terms">{{ 'CLIENT.clientConfirm.termsConditions2' | translate }}</a>
                {{ 'CLIENT.clientConfirm.termsConditions3' | translate }}
                <a target="_blank" routerLink="/privacy">{{ 'CLIENT.clientConfirm.termsConditions4' | translate }}</a
                >.
              </label>
              <div class="invalid-feedback" *ngIf="submitAttempted && !form.get('terms').valid">
                {{ 'CLIENT.clientConfirm.requiredField' | translate }}
              </div>
            </div>
            <!-- marketing -->
            <div>
              <input formControlName="marketing" type="checkbox" class="custom-control-input" id="customCheck2" />
              <label
                class="custom-control-label"
                for="customCheck2"
                [ngClass]="{ 'is-invalid': submitAttempted && !form.get('marketing').valid }"
              >
                {{ 'CLIENT.clientConfirm.marketingCheckbox' | translate }}
              </label>
            </div>
          </ng-container>
          <!-- corporate -->
          <ng-container *ngIf="merchant.corporate">
            <!-- BUK terms -->
            <div>
              <input formControlName="terms" type="checkbox" class="custom-control-input" id="customCheck1" />
              <label
                class="custom-control-label"
                for="customCheck1"
                [ngClass]="{ 'is-invalid': submitAttempted && !form.get('terms').valid }"
              >
                {{ 'CLIENT.clientConfirm.termsConditions1' | translate }}
                <a target="_blank" rel="canonical" routerLink="/terms">{{ 'CLIENT.clientConfirm.termsConditions2' | translate }}</a>
                {{ 'CLIENT.clientConfirm.termsConditions3' | translate }}
                <a target="_blank" rel="canonical" routerLink="/privacy">{{ 'CLIENT.clientConfirm.termsConditions4' | translate }}</a>
                {{ 'CLIENT.clientConfirm.termsConditions3b' | translate }}.
              </label>
              <div class="invalid-feedback" *ngIf="submitAttempted && !form.get('terms').valid">
                {{ 'CLIENT.clientConfirm.requiredField' | translate }}
              </div>
            </div>
            <!-- Corporate terms -->
            <div>
              <input formControlName="termsCorporate" type="checkbox" class="custom-control-input" id="customCheck1b" />
              <label
                class="custom-control-label"
                for="customCheck1b"
                [ngClass]="{ 'is-invalid': submitAttempted && !form.get('termsCorporate').valid }"
              >
                {{ 'CLIENT.clientConfirm.termsConditions1b' | translate }}
                <a target="_blank" rel="canonical" href="https://www.afflelou.pt/politica-de-privacidade-contacto">{{
                  'CLIENT.clientConfirm.termsConditions4' | translate
                }}</a>
                {{ 'CLIENT.clientConfirm.termsConditions4b' | translate }}
              </label>
              <div class="invalid-feedback" *ngIf="submitAttempted && !form.get('terms').valid">
                {{ 'CLIENT.clientConfirm.requiredField' | translate }}
              </div>
            </div>
            <!-- terms -->
            <!-- <div>
              <input formControlName="terms" type="checkbox" class="custom-control-input" id="customCheck3" />
              <label
                class="custom-control-label"
                for="customCheck3"
                [ngClass]="{ 'is-invalid': submitAttempted && !form.get('terms').valid }"
              >
                {{ 'CLIENT.clientConfirm.termsConditionsCorporate1' | translate }}
                (<a target="_blank" href="https://www.afflelou.pt/politica-de-privacidade-contacto">I</a>,<a
                  target="_blank"
                  routerLink="/terms"
                  >II</a
                >)
                {{ 'CLIENT.clientConfirm.termsConditionsCorporate2' | translate }}
                (<a target="_blank" href="https://www.afflelou.pt/condicoes-utilizacao">I</a>,<a target="_blank" routerLink="/privacy">II</a
                >).
              </label>
              <div class="invalid-feedback" *ngIf="submitAttempted && !form.get('terms').valid">
                {{ 'CLIENT.clientConfirm.requiredField' | translate }}
              </div>
            </div> -->
            <!-- marketing -->
            <!-- <div>
              <input formControlName="marketing" type="checkbox" class="custom-control-input" id="customCheck4" />
              <label
                class="custom-control-label"
                for="customCheck4"
                [ngClass]="{ 'is-invalid': submitAttempted && !form.get('marketing').valid }"
              >
                {{ 'CLIENT.clientConfirm.marketingCorporateCheckbox' | translate }}
              </label>
            </div> -->
          </ng-container>
        </div>
      </form>

      <app-alert type="danger" [msg]="errorMsg"></app-alert>

      <button
        id="submit2"
        *ngIf="!payOnlyPage && (!paymentsEnabled || form?.get('paymentMethod').value === 'money')"
        [disabled]="loading"
        class="btn btn-lg btn-black w100"
        (click)="confirmBooking()"
      >
        {{ 'CLIENT.clientConfirm.ctaConfirmBooking' | translate }}
      </button>
      <button
        id="submit"
        *ngIf="paymentsEnabled && form?.get('paymentMethod').value !== 'money'"
        [disabled]="loading"
        class="btn btn-lg btn-black w100"
        (click)="confirmBooking()"
      >
        {{ 'CLIENT.clientConfirm.ctaPayBooking' | translate }} {{ totalPriceToBePaid | currency : merchant.currency }}
      </button>
    </div>
  </div>
</div>
